<template>
  <div>
    <base-header class="header pb-8 pt-5 pt-lg-8 d-flex align-items-center">
      <!-- Mask -->
      <span class="mask bg-gradient-warning opacity-8"></span>
      <!-- Header container -->
      <div class="container-fluid d-flex align-items-center">
        <div class="row">
          <div class="col-lg-7 col-md-10">
            <p class="text-white mt-3 mb-5">
              Aqui você poderá criar uma nova chamada para startups, seja de
              aceleração ou de pré-aceleração. Para isso é necessário preencher
              as informações inicias abaixo.
            </p>
          </div>
        </div>
      </div>
    </base-header>

    <div class="container-fluid mt--8">
      <div class="row">
        <div class="col-xl-8">
          <card shadow type="secondary">
            <div slot="header" class="bg-white border-0">
              <div class="row align-items-center">
                <div class="col-8">
                  <h3 class="mb-0">Chamada de Startups</h3>
                </div>
              </div>
            </div>
            <template>
              <form
                class="vld-parent"
                ref="form_edit_container"
                @submit.prevent
              >
                <h6 class="heading-small text-muted mb-4">
                  Informações básicas
                </h6>
                <div class="pl-lg-4">
                  <div class="row">
                    <div class="col-lg-6">
                      <label class="form-control-label">
                        Fundo de investimento
                        <base-button
                          v-if="model.fund_id"
                          size="sm"
                          type="link"
                          class="p-0 m-0 ml-2"
                          @click="
                            $router.push(
                              '/admin/fundos/' + model.fund_id + '/editar'
                            )
                          "
                        >
                          Ver fundo
                        </base-button>
                      </label>
                      <div class="vld-parent" ref="inputFunds">
                        <base-input addon-left-icon="ni ni-tag">
                          <select class="form-control" v-model="model.fund_id">
                            <option selected disabled value="">
                              Selecione um fundo
                            </option>
                            <option
                              v-for="fund in funds"
                              :key="fund.id"
                              :value="fund.id"
                            >
                              {{ fund.tag }} - Fundo de {{ fund.type }}
                            </option>
                          </select>
                        </base-input>
                      </div>
                    </div>
                    <div class="col-lg-6">
                      <label class="form-control-label">
                        Status da chamada
                        <i
                          v-if="model.status"
                          class="fas fa-info-circle ml-1"
                          :title="getStatusDescription"
                        ></i>
                      </label>
                      <div>
                        <base-input addon-left-icon="fas fa-cogs">
                          <select class="form-control" v-model="model.status">
                            <option selected disabled value="">
                              Selecione o status da chamada
                            </option>
                            <option
                              v-for="status in callStatus"
                              :key="status.key"
                              :value="status.key"
                            >
                              {{ status.value }}
                            </option>
                          </select>
                        </base-input>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="pl-lg-4">
                  <div class="row">
                    <div class="col-lg-6">
                      <div>
                        <base-input
                          label="Nome da chamada"
                          v-model="model.name"
                          placeholder="Ex. Acelera Stars 2019"
                        />
                      </div>
                    </div>
                    <div class="col-lg-6">
                      <base-input label="Tipo">
                        <br />
                        <base-radio
                          name="Aceleração"
                          class="mb-3"
                          v-model="model.type"
                          :inline="true"
                        >
                          Aceleração
                        </base-radio>
                        <base-radio
                          name="Pré-aceleração"
                          class="mb-3"
                          v-model="model.type"
                          :inline="true"
                        >
                          Pré-aceleração
                        </base-radio>
                      </base-input>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-lg-6">
                      <div>
                        <base-input
                          label="Região"
                          v-model="model.region"
                          placeholder="Digite um local"
                        />
                      </div>
                    </div>
                    <div class="col-lg-6">
                      <base-input label="Limitar chamada para a região">
                        <br />
                        <base-switch
                          v-bind:value="model.region_limited"
                          @input="regionLimitedChangedHandler($event)"
                        />
                      </base-input>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-lg-6">
                      <label class="form-control-label"
                        >Data para o início das aplicações
                        <base-button
                          size="sm"
                          type="link"
                          class="p-0 m-0 ml-2"
                          @click="setCurrentDate()"
                        >
                          Usar data atual
                        </base-button></label
                      >
                      <base-input
                        type="date"
                        addon-left-icon="ni ni-calendar-grid-58"
                        placeholder="Data início"
                        input-classes="form-control"
                        v-model="model.start_date"
                      />
                    </div>
                    <div class="col-lg-6">
                      <label class="form-control-label"
                        >Data para o fim das aplicações</label
                      >
                      <base-input
                        addon-left-icon="ni ni-calendar-grid-58"
                        type="date"
                        placeholder="Data fim"
                        input-classes="form-control"
                        v-model="model.end_date"
                      />
                    </div>
                    <div class="col-12">
                      <span class="duration">
                        {{ calcDuration() }}
                      </span>
                    </div>
                  </div>
                </div>
                <hr class="my-4" />
                <h6 class="heading-small text-muted mb-4">
                  Informações do investimento
                </h6>
                <div class="pl-lg-4">
                  <div class="row">
                    <div class="col-lg-4">
                      <base-input label="Valor máximo financiado por empresa">
                        <div class="input-unit-box">
                          <input
                            type="text"
                            placeholder="Valor em reais"
                            class="form-control input-unit"
                            v-model="model.max_value"
                          />
                          <span class="unit">R$ </span>
                        </div>
                      </base-input>
                    </div>
                    <div class="col-lg-4">
                      <base-input label="Percentual máximo de capital assumido">
                        <div class="input-unit-box">
                          <input
                            type="text"
                            placeholder="Percentual"
                            class="form-control input-unit"
                            v-model="model.max_equity"
                          />
                          <span class="unit">% </span>
                        </div>
                      </base-input>
                    </div>
                    <div class="col-lg-4">
                      <base-input
                        type="number"
                        label="Máximo de startups (opcional)"
                        v-model="model.max_startups"
                        placeholder="Máximo de startups"
                      />
                    </div>
                  </div>
                </div>
                <hr class="my-4" />
                <h6 class="heading-small text-muted mb-4">
                  Informações complementares
                </h6>
                <div class="pl-lg-4">
                  <div class="row">
                    <div class="col">
                      <base-input
                        label="Setores"
                        placeholder="Separe-os por ;"
                        input-classes="form-control"
                        v-model="model.sectors"
                      />
                    </div>
                  </div>
                  <div class="row">
                    <div class="col">
                      <base-input label="Descrição (opcional)">
                        <textarea
                          rows="3"
                          class="form-control form-control"
                          placeholder="Descreva os detalhes do programa"
                          v-model="model.description"
                        >
                        </textarea>
                      </base-input>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col">
                      <base-input label="Observações (opicional)">
                        <textarea
                          rows="3"
                          class="form-control form-control"
                          placeholder="Escreva aqui"
                          v-model="model.observation"
                        >
                        </textarea>
                      </base-input>
                    </div>
                  </div>
                </div>
              </form>
            </template>
          </card>
        </div>
        <div class="col-xl-4 order-xl-1 mb-5 mb-xl-0 mt-6 mt-lg-0">
          <div class="card card-profile shadow">
            <div class="row justify-content-center">
              <div class="col-lg-3 order-lg-2">
                <div class="card-profile-image">
                  <img src="/img/pages/call.png" class="rounded-circle" />
                </div>
              </div>
            </div>
            <div class="card-header text-center border-0">
              <div class="d-flex justify-content-between"></div>
            </div>
            <div class="card-body pt-5 pt-md-4 pb-4">
              <div class="row">
                <div class="col">
                  <div
                    class="card-profile-stats d-flex justify-content-center mt-md-5"
                  >
                    <div>
                      <span class="heading">{{
                        formatValue(model.max_value)
                      }}</span>
                      <span class="description">Investimento máximo</span>
                    </div>
                    <div>
                      <span class="heading">{{
                        model.max_equity + " %" || "-"
                      }}</span>
                      <span class="description">Percentual máximo</span>
                    </div>
                    <div>
                      <span class="heading">{{
                        model.max_startups || "N/A"
                      }}</span>
                      <span class="description">Limite startups</span>
                    </div>
                  </div>
                </div>
              </div>
              <div class="text-center">
                <h3>
                  Região:
                  <span class="font-weight-light">
                    {{ model.region || "..." }}</span
                  >
                </h3>
                <h3>
                  Chamada aberta de:
                  <span class="font-weight-light">
                    {{ getYear(this.model.start_date) }} até
                    {{ getYear(this.model.end_date) }}
                  </span>
                </h3>
                <hr class="my-4" />
                <h2 class="text-center tag-title">
                  <i class="ni ni-tag"></i>
                  <span class="tag">{{ model.name }}</span>
                </h2>
                <div class="col-12 text-center" v-if="error">
                  <base-alert type="danger">{{ error }}</base-alert>
                </div>
                <base-button
                  type="danger"
                  :custom="true"
                  @click="handleOpenModalConfirmation()"
                  >Criar chamada</base-button
                >
              </div>
            </div>
          </div>
        </div>
      </div>

      <modal
        :show.sync="modals.confirmation"
        modal-classes="modal-default modal-dialog-centered"
      >
        <h6 slot="header" class="modal-title" id="modal-title-notification">
          Atenção!
        </h6>
        <div class="vld-parent" ref="modal_confirmation_create">
          <div class="py-3 text-center">
            <i class="fa fa-bullhorn fa-3x"></i>
            <h4 class="heading mt-4">Confirmar criação de nova chamada</h4>
            <p>
              Você realmente deseja criar a chamada
              <b class="font-weight-bold">{{ model.name }}</b
              >?
            </p>
            <p class="text-sm mt-3 mx-2">
              <i class="fas fa-info-circle mr-1"></i> Lembre-se, uma chamada com
              status 'Regular' fica visível e aceita inscrições de startups.
            </p>
          </div>
        </div>
        <template slot="footer">
          <base-button
            type="link"
            text-color="white"
            class="ml-auto"
            @click="modals.confirmation = false"
          >
            Voltar
          </base-button>
          <base-button type="white" @click="handleSubmit()">
            Confirmar
          </base-button>
        </template>
      </modal>

      <modal
        :show.sync="modals.emptyFunds"
        :closeOnClick="false"
        modal-classes="modal-warning modal-dialog-centered"
      >
        <h6 class="modal-title mb-4" id="modal-title-notification">Atenção!</h6>
        <div class="py-3 text-center">
          <i class="fa fa-exclamation-circle fa-3x"></i>
          <h4 class="heading mt-4">Nenhum fundo encontrado!</h4>
          <p>
            Antes de cadastrar uma nova chamada para startups você precisa ter
            cadastrado pelo menos um fundo de investimentos.
          </p>
        </div>

        <template slot="footer">
          <base-button
            type="link"
            text-color="white"
            class="ml-auto"
            @click="$router.push('/admin/chamadas')"
          >
            Voltar
          </base-button>
          <base-button type="white" @click="$router.push('/admin/fundos')">
            Ir para página de fundos
          </base-button>
        </template>
      </modal>
    </div>
  </div>
</template>
<script>
import api from "@/services/api.js";

export default {
  name: "chamada",
  data() {
    return {
      model: {
        fund_id: "",
        type: "",
        name: "",
        region: "",
        region_limited: false,
        start_date: "",
        end_date: "",
        sectors: "",
        description: "",
        observation: "",
        max_value: "",
        max_equity: "",
        max_startups: "",
        status: "",
      },
      error: "",
      funds: [],
      callStatus: [
        {
          key: "open",
          value: "Regular",
          description:
            "Uma chamada regular fica visível para os investidores cadastrados no fundo.",
        },
        {
          key: "closed",
          value: "Encerrada",
          description:
            "O status 'Encerrada' ficará visível para os investidores cadastrados no fundo.",
        },
        {
          key: "hidden",
          value: "Invisível",
          description:
            "Uma chamada invisível fica oculta para todos os investidores.",
        },
      ],
      modals: {
        confirmation: false,
        emptyFunds: false,
      },
    };
  },
  async mounted() {
    try {
      let loader = this.$loading.show({
        container: this.$refs.inputFunds,
        width: 35,
        height: 35,
      });
      const { data } = await api.get("/funds");
      if (data.length) this.funds = data;
      else this.modals.emptyFunds = true;
      loader.hide();
    } catch (e) {
      this.$toasted.error("Ocorreu um erro ao recuperar as informações");
    }
  },
  methods: {
    async handleSubmit() {
      const loader = this.$loading.show({
        container: this.$refs.modal_confirmation_create,
        opacity: 0,
        width: 140,
        height: 140,
      });
      const data = this.model;
      try {
        await api.post("/adm/startup-calls", data);
        this.$toasted.show("Nova chamada para startups criada com sucesso");
        this.$router.push("/admin/chamadas");
      } catch (e) {
        this.error = "Ocorreu um erro ao salvar a chamada. Tente novamente.";
        this.$toasted.error("Ocorreu um erro ao salvar as informações");
        this.modals.confirmation = false;
      }
      loader.hide();
    },
    handleOpenModalConfirmation() {
      this.error = "";
      const data = this.model;
      for (const key in data) {
        if (
          data[key] === "" &&
          ![
            "description",
            "observation",
            "max_startups",
            "sectors",
            "region",
          ].includes(key)
        ) {
          this.error =
            "Por favor, preencha todos os campos obrigatórios para prosseguir.";
          return;
        }
      }
      this.modals.confirmation = true;
    },
    setCurrentDate() {
      this.model.start_date = this.moment().format("YYYY-MM-DD");
    },
    calcDuration() {
      if (this.model.start_date && this.model.end_date) {
        const d1 = this.moment(this.model.start_date);
        const d2 = this.moment(this.model.end_date);
        let diffDays = d2.diff(d1, "days");
        if (diffDays <= 0) return "Data fim deve ser maior que data de início";
        return `* Duração da chamada: ${diffDays} dias`;
      }
    },
    regionLimitedChangedHandler(event) {
      if (typeof event === "boolean") this.model.region_limited = event;
    },
  },
  computed: {
    getStatusDescription() {
      const selectedStatus = this.callStatus.find(
        (status) => status.key === this.model.status
      );
      return selectedStatus ? selectedStatus.description : "";
    },
  },
};
</script>
<style scoped>
.input-unit-box {
  position: relative;
}

.input-unit {
  display: block;
  border: 1px solid #d7d6d6;
  background: #fff;
  padding: 10px 10px 10px 30px;
}

.unit {
  position: absolute;
  display: block;
  left: 5px;
  top: 10px;
  z-index: 9;
  color: #444444;
}

.duration {
  text-transform: uppercase;
  font-size: 12px;
  color: #444444;
}

.duration,
.tag {
  font-family: inherit;
  font-weight: 600;
  line-height: 1.5;
}

.tag {
  font-size: 18px;
  margin-left: 1em;
  color: black;
}

.tag-title {
  margin-bottom: 1.2em;
}
</style>
